import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import StagesManager from "../components/StagesManager";
import Configurer from '../components/Configurer'
import { siteConfig, siteTheme } from "../variables/config";
import { pathMaker, translate, fetchWallpaper } from "../utils/useful";
import HttpServices from "../utils/Http.services";
import SignUpUserTypeStep from "./signup/SignUpUserTypeStep";
import SignUpUsernameStep from "./signup/SignUpUsernameStep";
import SignUpFormStep from "./signup/SignUpFormStep";
import SignUpSuccessStep from "./signup/SignUpSuccessStep";
import { withRouter } from "react-router-dom";

const colors = siteTheme.primaryColors

class SignUp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
      mainOpacity: 1,
      wallpaper: '/images/wallpapers/1.jpg',
    }
  }

  componentDidMount() {
    if (this.props.user.loggedin) {
      this.props.history.push(pathMaker('/'))
    }
    fetchWallpaper('signup', {}, (wallpaper) => {
      if (wallpaper) {
        this.setState({ wallpaper })
      }
    })
  }

  setData = (newData, cb) => {
    let data = { ...this.state.data, ...newData }
    this.setState({ data }, () => {
      if (cb) { cb() }
    })
  }

  changeStage = (newStage, cb) => {
    if (this.stageManager) {
      this.stageManager.changeStage(newStage, cb)
    }
  }

  lastStage = () => {
    if (this.stageManager) {
      this.stageManager.lastStage()
    }
  }

  submitSignup = (cb) => {
    let data = { ...this.state.data }
    
    // Remove confirmPassword before sending
    delete data.confirmPassword

    HttpServices.request('userSignup', data, (result, error) => {
      if (error) {
        cb(null, error)
      } else {
        cb(result, null)
      }
    })
  }

  render() {
    return (
      <Configurer
        settingsInfo={{ showFooter: true, showTabBar: false, showHeader: true, headerTitle: '' }}
        title={translate("Sign Up")}
        description={translate("Create a new account")}
      >
        <section className="d-flex w-100 position-relative" style={{ 
          minHeight: '100vh', 
          padding: '0px',
          background: `linear-gradient(105deg, rgba(16, 69, 61, 0.38) 0%, rgba(16, 69, 61, 0.15) 50%, rgba(20, 106, 93, 0.48) 100%)`
        }}>
          <section className="row w-100 m-0">
            <section className="d-none d-md-block col-12 col-md-5 col-lg-4" style={{ 
              height: '100vh', 
              position: 'sticky', 
              top: 0, 
              padding: '100px 30px 20px 30px', 
              textAlign: 'center', 
              backgroundImage: "url(" + this.state.wallpaper + ")", 
              backgroundPosition: 'center', 
              backgroundSize: 'cover' 
            }}>
              <div className="h-100 w-100" style={{ 
                background: `linear-gradient(to top, rgba(16, 69, 61) 0%, rgba(20, 106, 93) 100%), linear-gradient(to right, transparent 0%, rgba(226, 193, 158, 0.3) 100%)`, 
                position: 'absolute', 
                top: 0, 
                left: 0 
              }}></div>
              <div style={{ position: 'relative' }}>
                <img className=" mb-2" src={siteTheme.logo} width={'90px'} />
                <h1 className="text-ultra-big" style={{ color: colors.main3 }}>{siteConfig.siteName}</h1>
                <h1 className="text-big mt-2" style={{ whiteSpace: 'nowrap', color: colors.main3 }}>{translate('Create Account')}</h1>
                <p style={{ cursor: 'pointer', fontSize: 15, marginTop: 10, color: colors.main3, opacity: 0.9 }}>
                  {translate('Join our community today')}
                </p>
              </div>
            </section>

            <section className="col-12 col-md-7 col-lg-8 pb-5" style={{ 
              opacity: this.state.mainOpacity, 
              transition: 'all 0.5s', 
              flex: '1 1 auto', 
              paddingTop: 100,
              background: `linear-gradient(105deg, rgba(16, 69, 61, 0.02), rgba(226, 193, 158, 0.03), rgba(20, 106, 93, 0.04))`
            }}>
              <StagesManager ref={el => this.stageManager = el}>
                <SignUpUserTypeStep 
                  initData={this.state.data} 
                  setData={this.setData} 
                  stage={0} 
                  stageName={'userType'} 
                  stageManager={this.stageManager}
                />
                <SignUpUsernameStep 
                  initData={this.state.data} 
                  setData={this.setData} 
                  stage={1} 
                  stageName={'username'} 
                  stageManager={this.stageManager}
                />
                <SignUpFormStep 
                  initData={this.state.data} 
                  setData={this.setData} 
                  submitSignup={this.submitSignup}
                  stage={2} 
                  stageName={'form'} 
                  stageManager={this.stageManager}
                />
                <SignUpSuccessStep 
                  initData={this.state.data} 
                  stage={3} 
                  stageName={'success'} 
                  stageManager={this.stageManager}
                />
              </StagesManager>
            </section>
          </section>
        </section>
      </Configurer>
    )
  }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SignUp));

